import { ComponentType } from 'react';
import { CardId } from './types';
import { ServiceChartCard, ServiceTableCard } from './ServiceCards';
import { MatchChartCard, MatchTableCard } from './MatchCards';
import { EndReasonTypeChartCard, EndReasonTypeTableCard } from './EndReasonTypeCards';
import { FafsaChartCard, FafsaTableCard } from './FafsaDashboard';
import { NotificationsCard } from './NotificationsDashboard';
import { TotalStudentsCard } from './StudentDashboard';
import { SchoolEnrollmentCard } from './SchoolEnrollmentDashboard';
import { ParticipantsChartCard } from './ParticipantsCards';
import { ParticipantsTableCard } from './ParticipantsCards';


type DashboardCardComponent = ComponentType<{}>;

export const DASHBOARD_CARD_REGISTRY: Partial<Record<CardId, DashboardCardComponent>> = {
    'service-chart': ServiceChartCard,
    'service-table': ServiceTableCard,
    'match-chart': MatchChartCard,
    'match-table': MatchTableCard,
    'end-reason-type-chart': EndReasonTypeChartCard,
    'end-reason-type-table': EndReasonTypeTableCard,
    'fafsa-chart': FafsaChartCard,
    'fafsa-table': FafsaTableCard,
    'participants-chart': ParticipantsChartCard,
    'participants-table': ParticipantsTableCard,
    'notifications': NotificationsCard,
    'total-students': TotalStudentsCard,
    'school-enrollment': SchoolEnrollmentCard,
};